import CryptoJS from 'crypto-js'

window.dataLayer = window.dataLayer || []

const hash = (value) => {
  if (!value) {
    return undefined
  }
  return CryptoJS.SHA256(value.toLowerCase().trim()).toString()
}

export const trackOptionSelect = ({ optionIndex, optionName, optionValue }) => {
  const data = {
    event: 'kitchen_quote.click',
    kitchen_quote: {
      pageId: `quiz/${optionIndex}`,
    },
  }
  if (optionName) {
    data.kitchen_quote.clickedElement = optionName
  }
  if (optionValue) {
    data.kitchen_quote.options = optionValue
  }
  window.dataLayer.push(data)
}

// options = { storage_option: string, quantity: number }
export const trackStorageOptionSelect = ({ optionIndex, options }) => {
  const data = {
    event: 'kitchen_quote.click',
    kitchen_quote: {
      pageId: `quiz/${optionIndex}`,
    },
  }
  if (options) {
    data.kitchen_quote.options = options
  }
  window.dataLayer.push(data)
}

export const trackSubmit = ({
  email,
  buttonText,
  paymentOption,
  paymentTerm,
  quotePrice,
  newletter,
}) => {
  window.dataLayer.push({
    event: 'kitchen_quote.submit',
    event_label: hash(email),
    newsletter_checkbox: newletter,
    cost_estimate: quotePrice,
    payment_option: paymentOption,
    payment_term: paymentTerm,
    kitchen_quote: {
      clickedElement: buttonText,
    },
  })
}
